export const NMC = {
  25001: 'МТС',
  25002: 'МегаФон',
  25003: 'Ростелеком (НСС, Элайн)',
  25004: 'МТС (Сибчеллендж)',
  25005: 'Теле2 (ЕТК)',
  25006: 'Билайн (DANYCOM)',
  25007: 'Смартс (больше не работает)',
  25008: 'Вайнах Телеком',
  25009: 'Теле2 (Скайлинк)',
  25010: 'МТС (Донтелеком)',
  25011: 'Yota (до 4 июня 2003 года использовался оператором Оренсот[1] в Оренбургской области)',
  25012: 'АКОС, Дальсвязь (ныне Теле2)',
  25013: 'МТС (бывшее название Кубань GSM)',
  25014: 'МегаФон (точно такой же как у 25002)',
  25016: 'Miatel',
  25017: 'Tele2',
  25018: 'Астран (MVNO Tele2)',
  25019: 'Индиго GSM (прекратила свое существование)',
  25020: 'Tele2, Tele2 / АКОС',
  25023: 'ЗАО «Джи Ти Эн Ти»',
  25026: 'ООО "ВТБ Мобайл" (MVNO Tele2)',
  25027: 'Летай (ТАТТЕЛЕКОМ)',
  25030: 'ЗАО «Остелеком»',
  25032: 'WIN-Mobile («К-Телеком», Республика Крым и Севастополь)',
  25033: 'СевМобайл',
  25034: 'Крымтелеком',
  25035: 'МОТИВ',
  25037: 'MCN Telecom',
  25039: 'Ростелеком (Utel, АКОС, НСС, БайкалВестКом, Волгоград-GSM, Тамбов GSM)',
  25040: 'АО "Воентелеком" (MVNO Tele2)',
  25042: 'ОАО «Межрегиональный ТранзитТелеком»',
  25043: 'ООО «Спринт»',
  25045: 'Газпромбанк Мобайл (MVNO Tele2)',
  25050: 'ООО "Сбербанк-Телеком"',
  25052: 'Easy4',
  25054: 'ПАО «Таттелеком»',
  25055: 'НП "ГЛОНАСС"',
  25059: 'Wifire',
  25060: 'Волна мобайл («КТК-Телеком», Республика Крым и Севастополь)',
  25061: 'Интертелеком (Прекратил работу)',
  25062: 'Тинькофф Мобайл (MVNO Tele2)',
  25077: 'АО "ГЛОНАСС"',
  25091: 'Соник Дуо (прекратил работу)',
  25092: 'МТС (Примтелефон)',
  25099: 'Билайн, НТК'
};
